/*******************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2024 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ******************************************************************************/
import * as React from "react";
import styled from "styled-components";
import { webComponentShim } from "components/shared/WebComponentShim";
import { ElementSize } from "@spectrum-web-components/base";

interface ProgressCircleProps {
  progressPercentage?: number | null;
}

const StyledProgressCircle = styled(webComponentShim("sp-progress-circle"))``;

export const ProgressCircle: React.FC<ProgressCircleProps> = ({
  progressPercentage,
}) => {
  const props = {
    progress: progressPercentage ?? 0,
    size: "s" as ElementSize,
    slot: "icon",
    ariaLabel: I18n.t("downloads_modal.downloading"),
    ...(progressPercentage === null && { indeterminate: true }),
  };

  return <StyledProgressCircle {...props} />;
};
